import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

// Number formatting helpers - always use Vietnamese format (dot as thousand separator)
export const formatNumber = (value: string | number | null | undefined): string => {
    if (value === '' || value === null || value === undefined) return '';
    const num = typeof value === 'string' 
        ? parseFloat(value.replace(/\./g, '').replace(',', '.')) 
        : value;
    if (isNaN(num)) return String(value);
    // Format with dot as thousand separator (Vietnamese style: 1.000.000)
    return Math.floor(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const parseCurrency = (formatted: string): string => {
    // Remove thousand separators to get raw number
    return formatted.replace(/\./g, '').replace(',', '.');
};
